export const defaultFormikConfig = {
	validateOnChange: false,
	validateOnMount: false,
};
